import React from 'react';

const Privacy = ({isNewUser,classNames}) => {
    return (
             <div className="text-center">
              <a
                 href="https://talent14.com/gizlilik-ve-cerez-politikasi/"
                 target="_blank"
                 rel="noopener noreferrer"
                className={classNames("text-decoration-none me-3 text-light")}
              >
                Gizlilik bildirimi
              </a>
              <a
                 href="https://talent14.com/uyelik-sozlesmesi-ve-site-kullanim-kosullari/"
                 target="_blank"
                 rel="noopener noreferrer"
                className={classNames("link-light text-decoration-none text-light")}
              >
                Kullanım Şartları
              </a>
            </div>
    );
};

export default Privacy;